import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DxDataGridModule } from 'devextreme-angular';
import { AppComponent } from './app.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { ErrorRutaComponent } from './components/error-ruta/error-ruta.component';
import { AppRoutingModule } from './app-routing.module';
import { AgendaService } from './services/agenda.service';
import { AdjuntarArchivosService } from './services/adjuntar-archivos.service';
import { AdjuntarArchivosComponent } from './components/adjuntar-archivos/adjuntar-archivos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { CrmEstadosService } from './services/crm-estados.service';
import { HistoricoEstadosComponent } from './components/historico-estados/historico-estados.component';
import { HttpClientModule } from '@angular/common/http';
import { GlobalVersionModule } from '@cf-v5-workspace/global-version';

@NgModule({
  declarations: [AppComponent, InicioComponent, ErrorRutaComponent, AdjuntarArchivosComponent, HistoricoEstadosComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxDataGridModule,
    HttpClientModule,
    GlobalVersionModule
  ],
  providers: [AgendaService, AdjuntarArchivosService, NgbModal, CrmEstadosService],
  bootstrap: [AppComponent],
})
export class AppModule {}
